<template>
  <v-snackbar
    :value="notifications.length"
    :timeout="-1"
    max-width="100%"
    centered
    shaped
    top
  >
    <v-layout
      justify-space-between
      align-center
    >
      <v-icon
        color="error"
        class="mr-n3"
      >
        info_outlined
      </v-icon>

      <template v-for="(n, i) in notifications">
        <pb-proxy-notification
          :key="`n-${i}`"
          v-bind="n"
        />

        <v-divider
          v-if="i < notifications.length - 1"
          :key="`d-${i}`"
          class="mx-3"
          vertical
        />
      </template>
    </v-layout>
  </v-snackbar>
</template>

<script>
import PbProxyNotification from './PbProxyNotification.vue';

export default {
  name: 'PbProxyNotifications',

  props: {
    notifications: {
      type: Array,
      required: true,
    },
  },

  components: {
    PbProxyNotification,
  },
};
</script>
